import { API, standardResponse } from "./middleware";

export async function search(dataSearch) {
  return API.post("api/requests/search", dataSearch)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function create(requestData) {
  return API.post("api/requests/create", requestData)
    .then((response) => response)
    .catch((error) => standardResponse(false, error.response?.data));
}
